import { Button } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import BackButtonIcon from "../../../assets/icons/BackButtonIcon";
import PLACEHOLDER_IMG from "../../../assets/images/avatar.svg";
import { useGetMeQuery } from "../../../features/superAdmin/employeeService/employeeManagementService";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { capitalize } from "../../../utils/string";

export default function AdminProfile() {
  const userId = useAppSelector((state) => state.auth.user?.id);
  const navigate = useNavigate();
  const [tabContentOfficial, setTabContentOfficial] = useState(true);
  const { data } = useGetMeQuery(userId as unknown as string, {
    skip: !userId,
  });

  const { officialInfo, personalInfo } = data?.data || {};

  const employeeOfficialData = [
    { label: "Name", value: officialInfo?.name || "N/A" },
    { label: "Email", value: officialInfo?.email || "N/A" },
    { label: "Department", value: officialInfo?.department?.name || "N/A" },
    {
      label: "Sub Department",
      value: officialInfo?.sub_department?.name || "N/A",
    },
    { label: "Designation", value: officialInfo?.designation || "N/A" },
    {
      label: "Line Manager",
      value: officialInfo?.line_manager_info?.officialInfo?.name || "N/A",
    },
    { label: "Date of joining", value: officialInfo?.date_of_joining || "N/A" },
    {
      label: "Employee Type",
      value: capitalize(officialInfo?.employee_type || "") || "N/A",
    },
    { label: "Employee ID", value: officialInfo?.giver_employee_id || "N/A" },
    { label: "Grade", value: officialInfo?.grade || "N/A" },
  ];

  const employeePersonalData = [
    { label: "Gender", value: capitalize(personalInfo?.gender || "") || "N/A" },
    { label: "Phone", value: personalInfo?.phone || "N/A" },
    // { label: "Date of Birth", value: personalInfo?.date_of_birth || "N/A" },
    { label: "Address", value: personalInfo?.address || "N/A" },
    { label: "Nationality", value: personalInfo?.nationality || "N/A" },
    { label: "Blood Group", value: personalInfo?.blood_group || "N/A" },
  ];

  return (
    <SidebarLayout title="Profile">
      {/* {open.type === "UPDATE" && (
        <AddNewUserModal
          open={open.open}
          type={open?.type}
          data={open?.data}
          handleClose={handleClose}
        />
      )} */}
      <div className="p-3 border border-slate-200 rounded-md bg-white">
        <Button
          className="flex items-center gap-2"
          onClick={() => navigate(-1)}
        >
          <BackButtonIcon />
          <span>Back</span>
        </Button>
      </div>

      <div className="flex justify-between items-center mt-4 border border-slate-200 p-4 rounded-md bg-white">
        <div className="flex gap-4 items-center">
          <img
            className="size-12 rounded-full"
            src={personalInfo?.pro_pic || PLACEHOLDER_IMG}
            alt={officialInfo?.name}
          />
          <div>
            <div className="text-lg font-semibold">{officialInfo?.name}</div>
            <div className="text-sm">{officialInfo?.designation}</div>
          </div>
        </div>
        <div className="flex gap-2 items-center">
          {/* <Radio.Group
            value="Active"
            options={[
              { value: "Active", label: "Active" },
              { value: "Deactivate", label: "Deactivate" },
            ]} */}
          {/* /> */}
          {/* <Button>
            <PrintIcon />
          </Button> */}
          {/* <Button type="primary">
            <SettingIcon />
          </Button> */}
        </div>
      </div>

      <div className="grid grid-cols-4 mt-4 gap-4 bg-white p-4 rounded-md">
        <div className="col-span-1">
          <Button
            block
            className={`border-none focus:ring-0 ${
              tabContentOfficial
                ? "text-[#FE7235] bg-[#FFF1EB80]"
                : "bg-transparent shadow-none"
            }`}
            onClick={() => setTabContentOfficial(true)}
          >
            Official
          </Button>
          <Button
            block
            className={`border-none focus:ring-0 ${
              !tabContentOfficial
                ? "text-[#FE7235] bg-[#FFF1EB80]"
                : "bg-transparent shadow-none focus:ring-0"
            }`}
            onClick={() => setTabContentOfficial(false)}
          >
            Personal
          </Button>
        </div>
        <div className="col-span-3">
          {tabContentOfficial && (
            <table>
              <tbody>
                {employeeOfficialData.map((data) => (
                  <tr className="border-b border-slate-100" key={data.label}>
                    <td className="text-[#8897AE] p-2">{data.label}</td>
                    <td className="text-[#455468] p-2">{data.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {!tabContentOfficial && (
            <table className="min-w-[200px]">
              <tbody>
                {employeePersonalData.map((data) => (
                  <tr className="border-b border-slate-100" key={data.label}>
                    <td className="text-[#8897AE] p-2">{data.label}</td>
                    <td className="text-[#455468] p-2">{data.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {/* <Button
            onClick={() =>
              handleOpen({
                type: "UPDATE",
                data: data?.data as unknown as undefined,
              })
            }
            className="text-[#FE7235] border-[#FE7235] flex items-center gap-2 px-10 mt-4"
          >
            <EditButtonIcon />
            <span>Edit</span>
          </Button> */}
        </div>
      </div>

      {/* <TicketPerformanceChart /> */}
      {/* <PendingTickets /> */}
    </SidebarLayout>
  );
}
